import React, { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import RadioGroup from "@mui/material/RadioGroup";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { makeStyles } from "@mui/styles";
import Tabbar from "../../assets/tabbar-ios.png";
import TopBar from "../../assets/top-bar.png";
import EmptyIphone from "../../assets/iphone-empty.png";

import Search1 from "../../assets/search1.png";
import Search2 from "../../assets/search2.png";
import Search3 from "../../assets/search3.png";
import Search4 from "../../assets/search4.png";
import Search5 from "../../assets/search5.png";
import Search6 from "../../assets/search6.png";

import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import { CircularProgress } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import { useAlert } from "react-alert";
import { useTranslation } from "react-i18next";

import ShowcaseTabBar from "../../components/ShowcaseTabBar/ShowcaseTabBar";
import ShowcaseSearch from "../../components/ShowcaseSearch/ShowcaseSearch";
import ShowcaseTopBar from "../../components/ShowcaseTopBar/ShowcaseTopBar";
import { CreatorContext } from "../../context/CreatorContext";

const useStyles = makeStyles({
	iphone: {
		width: 260,
		padding: 20,
		paddingTop: 0,
	},
	cardInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardPageInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardOptions: {
		display: "flex",
		flexDirection: "column",
	},
	cardForm: {
		display: "flex",
	},
	cardGrid: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
});

export default function Search({ drawerWidth }) {
	const classes = useStyles();
	const [search, setSearch] = useState(null);
	const [loading, setLoading] = useState(false);
	const { user } = useContext(UserContext);
	const alert = useAlert();
	const { t } = useTranslation();
	const { creator } = useContext(CreatorContext);

	const searchs = [
		{
			value: "search1",
			label: (
				<>
					<b>{t("search.style")} 1</b>: {t("search.search1")}
				</>
			),
			image: Search1,
		},
		{
			value: "search2",
			label: (
				<>
					<b>{t("search.style")} 2</b>: {t("search.search2")}
				</>
			),
			image: Search2,
		},
		{
			value: "search3",
			label: (
				<>
					<b>{t("search.style")} 3</b>: {t("search.search3")}
				</>
			),
			image: Search3,
		},
		{
			value: "search4",
			label: (
				<>
					<b>{t("search.style")} 4</b>: {t("search.search4")}
				</>
			),
			image: Search4,
		},
		{
			value: "search5",
			label: (
				<>
					<b>{t("search.style")} 5</b>: {t("search.search5")}
				</>
			),
			image: Search5,
		},
		{
			value: "search6",
			label: (
				<>
					<b>{t("search.style")} 6</b>: {t("search.search6")}
				</>
			),
			image: Search6,
		},
	];

	const getSearchData = async () => {
		setLoading(true);
		try {
			const res = await axios.get(ADMIN_URL + "creators", {
				headers: { authorization: localStorage.getItem("token") },
			});
			setSearch(
				searchs.find((search) => {
					return search.value === res.data.searchType;
				})
			);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	useEffect(() => {
		getSearchData();
	}, []);

	const saveSearchData = async () => {
		setLoading(true);
		try {
			await axios.post(
				ADMIN_URL + "creators",
				{
					searchType: search.value,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			alert.show(t("general.success"), { type: "success" });
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	return (
		<Box
			component="main"
			sx={{
				flexGrow: 1,
				bgcolor: "background.default",
				p: 3,
				width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
			}}
		>
			<Toolbar />

			<Card variant="outlined">
				<>
					<CardContent>
						<Typography
							sx={{
								fontSize: 14,
								borderBottom: "1px solid #f0f0f0",
								minHeight: "35px",
								marginBottom: "20px",
								marginLeft: "-20px",
								marginRight: "-20px",
								padding: "0px 20px 20px",
							}}
							color="text.secondary"
							gutterBottom
						>
							{t("search.title")}
						</Typography>
						<Box
							className={classes.cardPageInfo}
							sx={{
								flexFlow: {
									xs: "column-reverse",
									sm: "column-reverse",
									md: "row",
								},
							}}
						>
							<Box
								className={classes.cardOptions}
								sx={{
									minWidth: {
										xs: 0,
										sm: 0,
										md: 400,
									},
								}}
							>
								<RadioGroup
									aria-labelledby="demo-radio-buttons-group-label"
									value={search && search.value}
									name="radio-buttons-group"
									onChange={(e) => {
										setSearch(searchs.find((p) => p.value === e.target.value));
									}}
								>
									{searchs.map((search) => {
										return (
											<FormControlLabel
												key={search.value}
												value={search.value}
												control={
													<Radio
														disabled={[
															"building",
															"built",

															"publishing",
															"published",
															"inviting",
														].find(
															(status) =>
																status ===
																(user.app.appStatuses.length === 0
																	? ""
																	: user.app.appStatuses.length > 0 &&
																	  user.app.appStatuses[0].status)
														)}
													/>
												}
												label={search.label}
												sx={{
													marginBottom: {
														xs: 1,
														sm: 1,
														md: 0,
													},
												}}
											/>
										);
									})}
								</RadioGroup>
							</Box>
							<div
								className={classes.iphoneContainer}
								style={{ position: "relative" }}
							>
								<img
									src={EmptyIphone}
									alt="iphone"
									onMouseOver={() => {}}
									onMouseLeave={() => {}}
									className={classes.iphone}
								/>
								<img
									src={TopBar}
									alt="iphone"
									onMouseOver={() => {}}
									onMouseLeave={() => {}}
									className={classes.iphone}
									style={{
										position: "absolute",
										top: 0,
										left: 0,
										zIndex: 3,
										WebkitUserDrag: "none",
									}}
								/>

								<Box
									sx={{
										position: "absolute",
										top: 0,
										bottom: 0,
										padding:
											"53.75px 29px 72.25px 30px" /*"55.25px 29px 73px 30.25px",*/,
										width: 260,
										zIndex: 2,
									}}
									draggable={false}
								>
									<Box sx={{ marginTop: "-45px" }}>
										{/* CAMBIAR QUAN TINGUEM EL TIPO DE APP */}
										<ShowcaseTopBar
											title={t("search.search")}
											showDrawer={creator.navigationType === "Drawer"}
										/>
									</Box>
									<Box
										id="showcase"
										sx={{
											width: "100%",
											aspectRatio:
												creator.navigationType === "Drawer"
													? "220 / 427"
													: "220 / 386.5",
											borderBottomRightRadius:
												creator.navigationType === "Drawer" ? "26px" : 0,
											borderBottomLeftRadius:
												creator.navigationType === "Drawer" ? "26px" : 0,
											overflow: "auto",
											display: "flex",
											flexDirection: "column",
										}}
									>
										<ShowcaseSearch
											search={search}
											sector={
												user?.app?.appSubtype?.toLowerCase() ?? "ecommerce"
											}
										/>
									</Box>
									{creator.navigationType === "Tab Bar" && (
										<Box
											sx={{
												height: "38px",
											}}
										>
											<ShowcaseTabBar />
										</Box>
									)}
								</Box>
							</div>
						</Box>
					</CardContent>
					{!["inviting", "building", "built", "publishing", "published"].find(
						(status) =>
							status ===
							(user.app.appStatuses.length === 0
								? ""
								: user.app.appStatuses.length > 0 &&
								  user.app.appStatuses[0].status)
					) && (
						<CardActions sx={{ justifyContent: "right" }}>
							<Button
								variant="contained"
								onClick={() => {
									saveSearchData();
								}}
								size="small"
								disabled={loading}
							>
								{loading ? <CircularProgress size={12} /> : t("general.save")}
							</Button>
						</CardActions>
					)}
				</>
			</Card>
		</Box>
	);
}
